import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getTransactions = ({
  churchId,
  page,
  pageSize,
  type = "all",
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  let queryString = queryBuilder.build();

  queryString += `&type=${type}`;

  return axios.get(`/churches/${churchId}/transactions${queryString}`);
};

export const useTransactions = ({
  churchId,
  page,
  pageSize,
  type,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "transactions",
      churchId,
      page,
      pageSize,
      type,
      JSON.stringify(queries)
    ],
    queryFn: () => getTransactions({ churchId, page, pageSize, type, queries }),
    select: data => data.result,
    enabled: !!churchId && !!page && !!pageSize && !!type
  });
};
